module.exports = __webpack_public_path__ + "media/ingredients/carrots--brown-1981bb6c.svg";